import React from 'react';
import { Target, Zap, ShieldCheck, TrendingUp } from 'lucide-react';

const PositioningSection: React.FC = () => {
  const pillars = [
    {
      icon: <Zap className="w-6 h-6 text-[#D4AF37] mb-6" />,
      title: "Investor-Ready",
      desc: "Businesses structured for banks, PE firms, and institutional lenders."
    },
    {
      icon: <ShieldCheck className="w-6 h-6 text-[#D4AF37] mb-6" />,
      title: "ESG-Aligned",
      desc: "Transparent operations that meet global procurement standards."
    },
    {
      icon: <Target className="w-6 h-6 text-[#D4AF37] mb-6" />,
      title: "Globally Visible",
      desc: "Commercial entities discovered by international procurement teams."
    },
    {
      icon: <TrendingUp className="w-6 h-6 text-[#D4AF37] mb-6" />,
      title: "Market Strength",
      desc: "Negotiate with buyers from a position of institutional clarity."
    }
  ];

  return (
    <section className="py-32 max-w-[1440px] mx-auto px-8">
      <div className="flex flex-col gap-16">
        {/* Narrative Header - Level 1 label */}
        <div className="max-w-4xl">
          <span className="text-zinc-400 text-[11px] font-black uppercase tracking-[0.3em] mb-6 block">Our Mandate</span>
          <h3 className="text-3xl md:text-5xl font-bold tracking-tighter leading-tight text-zinc-950 mb-8">
            We Are Not a Marketing Agency. We Are a Capital Enablement Partner.
          </h3>
          <p className="text-zinc-600 text-lg leading-relaxed">
            High-value African mines are systematically undervalued because they are poorly positioned. We specialize in transforming under-presented operations into bankable businesses.
          </p>
        </div>

        {/* Grid of Pillars - Glass Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {pillars.map((item, idx) => (
            <div 
              key={idx} 
              className="p-10 bg-white/40 backdrop-blur-sm hover:bg-white transition-all rounded-sm border border-white/40 shadow-sm hover:shadow-xl group"
            >
              <div className="p-3 bg-white rounded-sm inline-block mb-2 transition-all shadow-none">
                {item.icon}
              </div>
              <h4 className="font-bold text-[14px] uppercase tracking-widest mb-3 text-zinc-950">{item.title}</h4>
              <p className="text-sm text-zinc-500 leading-relaxed max-w-md">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PositioningSection;